import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AssetColor, AssetSize, Avatar, AvatarSize, Divider, DividerLine, Icon, IconName, Text, TextColor, TextTag, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'
import { LanguageSwitcher } from '@/application/i18n/components/LanguageSwitcher'

type ProfileMenuProps = {
  name: string | null
  displayRoles: string
  onProfile: () => void
  onLogout: () => void
}

export const ProfileMenu: FC<ProfileMenuProps> = ({ name, displayRoles, onProfile, onLogout }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.menu}>
      <div className={styles.menuArrow} />
      <div className={styles.menuUserSection}>
        <Avatar name={name ?? undefined} size={AvatarSize.Medium} />
        <div className={styles.menuUserInfo}>
          <div className={styles.menuUserName}>
            <Text variant={TextVariant.BodyStandardWeighted} tag={TextTag.Span}>
              {name}
            </Text>
            {displayRoles && (
              <>
                <Text variant={TextVariant.BodyStandard} tag={TextTag.Span} color={TextColor.Muted}>
                  |
                </Text>
                <Text variant={TextVariant.BodyStandard} tag={TextTag.Span} color={TextColor.Muted}>
                  {displayRoles}
                </Text>
              </>
            )}
          </div>
          <button className={styles.menuLogoutLink} onClick={onLogout}>
            {t('header.logout')}
          </button>
        </div>
      </div>
      <Divider line={DividerLine.Subtle} />
      <button className={styles.menuItem} onClick={onProfile}>
        <Icon name={IconName.User} size={AssetSize.XSmall} color={AssetColor.BrandPrimary} />
        <span>{t('header.profile')}</span>
      </button>
      <Divider line={DividerLine.Subtle} />
      <LanguageSwitcher />
    </div>
  )
}
